import React from 'react';

function Icon(props) {
  return (
    <svg width="35" height="35" fill="none" viewBox="0 0 35 35">
      <rect width="33" height="33" x="1" y="1" stroke={props.color} strokeWidth="2" rx="16.5"></rect>
    </svg>
  );
}

export default Icon;
